import React, { memo, useMemo } from 'react';
import { LoaderWidget, MFELoader, printerStatus } from '@jarvis/react-portal-addons';
import PropTypes from 'prop-types';
import StatusLoader from './styles';

import {
  getModuleDisplayedEvent,
  getModuleInitializedEvent,
  publishEvent,
} from '../../utils/analytics';

const MFE_REFS = {
  STATUS: '@jarvis/react-ecp-status-widget',
};

const StatusWidgetECP = ({ stack, deviceCache, consolidatedPortal }) => {
  const {
    pending: isLoadingDevices,
    data: devices,
  } = consolidatedPortal ? deviceCache : { pending: false, data: [] };

  const showStatusWidget = useMemo(
    () => !isLoadingDevices, [isLoadingDevices],
  );

  const hasLegacyDevice = useMemo(
    () => (isLoadingDevices
      ? false
      : devices?.some(device => printerStatus.isGen1OrGen2(device?.identity?.platformIdentifier))
    ),
    [devices, isLoadingDevices],
  );

  if (!showStatusWidget && consolidatedPortal) {
    return (
      <StatusLoader>
        <LoaderWidget data-testid="status-widget-loader" />
      </StatusLoader>
    );
  }

  return (
    <MFELoader
      analyticsEvents={{
        moduleDisplayed: getModuleDisplayedEvent('/ReactEcpStatusWidget/', 'Status'),
      }}
      card
      component={MFE_REFS.STATUS}
      data-testid="status-widget-mfe"
      header={false}
      onLoad={() => {
        publishEvent(getModuleInitializedEvent('ReactEcpStatusWidget'));
      }}
      stack={stack}
      stateFilter={['Active', 'Pending', 'Expired']}
      settings={{
        enableLocalization: true,
        showUsers: true,
      }}
      consolidated={consolidatedPortal}
      devices={consolidatedPortal ? devices : []}
      hasLegacyDevice={hasLegacyDevice}
    />
  );
};

StatusWidgetECP.defaultProps = {
  stack: 1,
  consolidatedPortal: false,
};

StatusWidgetECP.propTypes = {
  stack: PropTypes.number,
  consolidatedPortal: PropTypes.bool,
  deviceCache: PropTypes.shape({
    pending: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
    error: PropTypes.shape({
      message: PropTypes.string,
      code: PropTypes.number,
    }),
    isFetching: PropTypes.bool,
    forceFetch: PropTypes.func,
    makeApiCall: PropTypes.func,
    success: PropTypes.bool,
  }).isRequired,
};

export default memo(StatusWidgetECP);
